// extracted by mini-css-extract-plugin
var _1 = "Mm37k";
export { _1 as "divider" }
